import {  VisibilityRounded} from "@mui/icons-material";
import dayjs from '../../utils/dayjs-setup';
import { Alert, Button, Chip, GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel,InputWithLabel, SelectInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DialogType, FormActions, GetStatusPlanoConfig, usuarioEntity } from "../../utils/constants";
import * as yup from "yup";
import { UploadFileModal } from "../../components/planos/upload-file";
import { ModalShowLogs } from "../../components/planos/modal-show-logs";




const schema = yup.object({
  usuario: yup.string().required(),
  razon_social: yup.string().required(),
  celular: yup.string().required(),
  email: yup.string().email().required(),
  pass: yup.string().optional(),
  perfil: yup.number().required(),
  productos_asociados: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional(),
  agente_asociado: yup.object().optional().notRequired().nullable(),
  centro_op_destinos: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional().notRequired().nullable(),
  activo: yup.string().required(),
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

const PLANOS_DISCONTINUED_MSG =
  "El módulo de planos (impodatos) fue descontinuado. El envío de documentos al ERP se realiza por el servicio central.";

export const MaestroPlanosProcesos = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...usuarioEntity});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [roles,setRoles] = useState([]);
  const [productosOptions,setProductosOptions] = useState([]);
  const [proveedorOptions,setProveedorOptions] = useState([]);
  const [agentesOptions,setAgentesOptions] = useState([]);
  const [centrosOp,setCentrosOp] = useState([]);
  const [centrosOpDestino,setCentrosOpDestino] = useState([]);
  const [isOpenedUpload,setIsOpenedUpload] = useState(false);
  const [hasEnabledUpload,setHasEnabledUpload] = useState(false);
  const [modalLog,setModalLog] = useState({
    is_visible:false,
    header:{}
  });


    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
     loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      setHasEnabledUpload(false);
      setDataSetProductos([]);
      setTotalRows(0);
    }
    const loadCentrosOp = async(search)=>{
      const  {data:{value}} = await AxiosInstance.get("Sucursales/obtener-centros-operacion?search="+search);
      return value;
    }


    const loadItems = async () => {
      setDataSetProductos([]);
      setTotalRows(0);
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };



    const onShowDetailProduct = () => {
      dispatch({
        type: ActionTypes.setModalInfo,
        data: {
          title: "Funcionalidad descontinuada",
          message: PLANOS_DISCONTINUED_MSG,
          type: DialogType.peligro,
          isVisible: true,
        },
      });
    }

    const onOpenModalItem = (edit=false)=>{
      if (!edit){
        setProductoSeleccionado({...usuarioEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
    
      const urlService = typeAction === FormActions.AGREGAR?'maestros/agregar-usuario-and-products':'maestros/editar-usuario-and-products/'+dataForm.cod;
 
        let payload =  {
          usuario:dataForm.usuario,
          razon_social:dataForm.razon_social,
          celular:dataForm.celular,
          clave:dataForm.pass,
          email:dataForm.email,
          perfil:dataForm.perfil,
          ind_factura_electronica:dataForm.ind_factura_electronica,
          agente_asociado:dataForm.agente_asociado?.value,
          productos:dataForm.productos_asociados.map(prod=>prod.value),
          cod_proveedor:dataForm.proveedor_asociado?.value,
          activo:dataForm.activo,
          centro_op_asociado:dataForm.centro_op_asociado?.value,
          centro_op_destinos:dataForm.centro_op_destinos?.map(item=>item.value),
        };
      

        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }

    const onSearchProveedor = async (evt,value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-prov-by-filter", {
            search_query: value_search
          });
          setProveedorOptions(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }
    const onSearchAgente = async (evt,value_search) =>{

      if (value_search) {

         try{

          const { data: { value } } = await AxiosInstance.post("maestros/filtrar-agentes", {
            search: value_search
          });
          setAgentesOptions(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }

    const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
   }

    const searcProductoAsociado = async (event, newInputValue) => {
      try {
        let res = await onSearchProducto(newInputValue);
        setProductosOptions(res);
      } catch (e) {
  
      }
    }
    const searchCpAsociado = async (event, newInputValue) => {
      let value =  await loadCentrosOp(newInputValue.toLowerCase());
      setCentrosOp(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }
    const searchCpDestino = async (event, newInputValue) => {
      let value =  await loadCentrosOp(newInputValue.toLowerCase());
      setCentrosOpDestino(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }

  
    const columnsTable = [
      {
      
       key:"plano_id",
       keyValue:"plano_id",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"plano_user_name",
        keyValue:"plano_user_name",
        label:"Nombre original",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     
      {
      
        key:"plano_nombre",
        keyValue:"plano_nombre",
        label:"Nombre temporal",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"plano_fecha_creacion",
        keyValue:"plano_fecha_creacion",
        label:"Fecha de subida",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>dayjs.tz(props.value,"America/Bogota").format('YYYY-MM-DD HH:mm:ss'),
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"plano_estado",
        keyValue:"plano_estado",
        label:"Estado del plano",
        headerRender:(props)=>props.label,
        bodyRender:(props)=> <Chip color={GetStatusPlanoConfig(props.value).color} label={GetStatusPlanoConfig(props.value).name} />,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"proceso_ID_GEN",
        keyValue:"proceso_ID_GEN",
        label:"ID proceso",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
      },
       {
        key:"log",
        keyValue:"plano_id",
        label:"Logs",
        headerRender:(props)=>props.label,
        bodyRender:({value,info})=><Button size="small" disabled={[1,2].includes(info.plano_estado_id)}  onClick={e=>onShowDetailProduct(info)} variant="contained" startIcon={<VisibilityRounded/>} >LOG</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
    ];
   
    const configModal =  {
      titleModal: tipoAction === FormActions.AGREGAR? "Agregar usuario":'Modificar usuario',
      buttomsAction: tipoAction === FormActions.AGREGAR? [
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              onClick:()=>setIsVisibleModalDetalle(false),
              color:"secondary"
          }
          },
          {
            title:"Registrar",
            buttomProps:{ 
              type:"submit",
             // onClick:onSaveDataNewData
            }
          }
      ]:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key:"usuario",
          keyValue:"usuario",
          label:"Nombre completo",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        },
        {
          key:"razon_social",
          keyValue:"razon_social",
          label:"Razon social",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        },
        {
          key:"celular",
          keyValue:"celular",
          label:"Celular",
          component:InputWithLabel,
          inputProps:{
            type:"number",
            size:"small"
          }
        },
        {
          key:"email",
          keyValue:"email",
          label:"Correo",
          component:InputWithLabel,
          inputProps:{
            type:"email",
            size:"small"
          }
        },
        {
          key:"pass",
          keyValue:"pass",
          label:"Clave",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        }, 
        {
          key:"perfil",
          keyValue:"perfil",
          label:"Rol",
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:roles
          }
        },
        {
          key: "proveedor_asociado",
          keyValue: "proveedor_asociado",
          label: "Proveedor asociado",
          component: AutoCompleteInputWithLabel,
          responsiveSize:12,
          inputProps: {
            name: 'Proveedor',
            size:"small",
            fullWidth: true,
            isLoading: false,
            multiple:false,
            onInputChange: onSearchProveedor,
            options: proveedorOptions || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        }, 
        {
          key: "agente_asociado",
          keyValue: "agente_asociado",
          label: "Agente asociado",
          component: AutoCompleteInputWithLabel,
          responsiveSize:12,
          inputProps: {
            name: 'agente_asociado',
            size:"small",
            fullWidth: true,
            isLoading: false,
            multiple:false,
            onInputChange: onSearchAgente,
            options: agentesOptions || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        }, 
        {
          key: "productos_asociados",
          keyValue: "productos_asociados",
          label: "Productos asociados",
          component: AutoCompleteInputWithLabel,
          responsiveSize:12,
          inputProps: {
            size:"small",
            name: 'productos_asociados',
            fullWidth: true,
            isLoading: false,
            multiple:true,
            PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>,
            onInputChange: searcProductoAsociado,
            options: productosOptions || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        },
        {
          key: "centro_op_asociado",
          keyValue: "centro_op_asociado",
          label: "Centro de operacion mas cercano",
          component: AutoCompleteInputWithLabel,
          responsiveSize:12,
          inputProps: {
            size:"small",
            name: 'centro_op_asociado',
            fullWidth: true,
            isLoading: false,
            multiple:false,
            PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>,
            onInputChange: searchCpAsociado,
            options: centrosOp || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        },
        {
          key: "centro_op_destinos",
          keyValue: "centro_op_destinos",
          label: "Centros de operacion Destino",
          component: AutoCompleteInputWithLabel,
          responsiveSize:12,
          inputProps: {
            size:"small",
            name: 'centro_op_asociado',
            fullWidth: true,
            isLoading: false,
            multiple:true,
            PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>,
            onInputChange: searchCpDestino,
            options: centrosOpDestino || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        },

        {
          key:"activo",
          keyValue:"activo",
          label:"Estado",
          component:SelectInputWithLabel,
          inputProps:{
            size:"small",
            items:[
              {
                value:"ACTIVO",
                label:"Activo"
              },
              {
                value:"INACTIVO",
                label:"Inactivo"
              },
              {
                value:"POR CONFIRMAR",
                label:"Por confirmar"
              }
            ],
            type:"select",
       
          }
        },
        {
          key:"ind_factura_electronica",
          keyValue:"ind_factura_electronica",
          label:"¿Emite factura electronica?",
          component:SelectInputWithLabel,
          inputProps:{
            items:[
              {
                value:"SI",
                label:"SI"
              },
              {
                value:"NO",
                label:"NO"
              },
             
            ],
            type:"select",
       
          }
        },
        
      ]
    } ;

    return (<>
    
    <ModalShowLogs 
      {
        ...modalLog
      }
      onClose={()=>{
        setModalLog({
          is_visible:false,
          header:{}
        });
      }}
    />

    <UploadFileModal
    loadData={loadItems}
    dispatch={dispatch}
    is_opened={isOpenedUpload}
    onCloseAction={ ()=>setIsOpenedUpload(false) }
    />
   
    <Grid container spacing={2} >
      {/*   <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar usuario"
            
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid> */}
        <Grid item sm={12} xs={12} md={12} >
          <Alert severity="warning" sx={{ mb: 2 }}>
            {PLANOS_DISCONTINUED_MSG}
          </Alert>
          <Button
            disabled
            variant="contained"
            color="primary"
            onClick={() => {
              dispatch({
                type: ActionTypes.setModalInfo,
                data: {
                  title: "Funcionalidad descontinuada",
                  message: PLANOS_DISCONTINUED_MSG,
                  type: DialogType.peligro,
                  isVisible: true,
                },
              });
            }}
          >
            Subir plano
          </Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.plano_id}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell key={Col.keyValue}  >
                          {<Col.bodyRender info={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}